<template>
  <div class=" is-fullwidth">
    <div class="level">
        <div class="level-left">
          <div class="columns" >
            <div class=" col">
              <div class="select is-fullwidth">
                <select v-model="selected_garment_id" @change="addSelectedGarment" :disabled="orders_loading===true || garments_loading===true || garments.length===0">
                  <option value="">Select garment</option>
                  <option v-for="garment in garments" :key="garment.garmentID" :value="garment.garmentID">
                    {{ garment.garmentname }}
                  </option>
                </select>
              </div>
            </div>

            <div class=" col pl-2">
              <input type="date" class="input" v-model="start_date" :disabled="this.orders_loading==true"/>
            </div>
            <div class=" col pl-2" >
              <input type="date" class="input" v-model="end_date" :disabled="this.orders_loading==true"/>
            </div>
            <div class=" col pl-2">
              <div class="select is-fullwidth">
                <select v-model="selected_region" :disabled="orders_loading===true">
                  <option value="">All Regions</option>
                  <option v-for="region in regionOptions" :key="region" :value="region">{{ region }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pb-2">
        <button
          v-for="garment in selectedGarments"
          :key="'selected-' + garment.garmentID"
          class="button is-small is-link is-light mr-1 mb-1"
          @click="removeSelectedGarment(garment.garmentID)">
          {{ garment.garmentname }} x
        </button>
      </div>

      <p v-if="garment_selection_error !== ''" class="has-text-danger is-size-7 pb-2">{{ garment_selection_error }}</p>

      <button @click="getOrders()" class="button is-primary is-small mb-3" :disabled="orders_loading===true || garments_loading===true">Get Orders</button>
    
    

    <table class="table is-hoverable is-fullwidth is-size-7" id="orderstable" >
    	<thead>
    		<tr>
        <th>PO Number</th>
        <th>Customer</th>
        <th>Region </th>
         <th>Range</th>
        <th>Garment</th>
       
        <th>Design Name</th>
          <th>Qty</th>
          <th>Order Date</th>
          
          <th v-for="size in activeSizes" :key="size.database_name">{{ size.name }}</th>
         
   	 	    </tr>
    	</thead>
    	<tbody>
		    
        <tr v-for="order in filteredOrders" v-bind:key="order.orderID" v-show="orders_loading===false">
          <td >{{order.ponumber}}</td>
          <td>{{order.clientname}}</td>
          <td>{{order.region}}</td>
           <td>{{order.range}}</td>
          <td>{{order.garmentname}}</td>  
         
          <td>{{order.designname}}</td>
           <td>{{ order.total_qty }}</td>
          <td>{{order.orderdate}}</td>
          <td v-for="size in activeSizes" :key="size.database_name">{{ order[size.database_name] || 0 }}</td>
          
          
			</tr>
      </tbody>
      <tfoot v-if="filteredOrders.length > 0 && orders_loading === false">
        <tr class="has-background-light has-text-weight-bold">
          <td colspan="7">Totals</td>
          <td></td>
          <td v-for="size in activeSizes" :key="'total-' + size.database_name">{{ sizeTotals[size.database_name] || 0 }}</td>
         
        </tr>
        <tr class="has-background-light has-text-weight-bold">
          <td colspan="7">% of Total</td>
          <td></td>
          <td v-for="size in activeSizes" :key="'pct-' + size.database_name">
            {{ grandTotal > 0 ? ((sizeTotals[size.database_name] || 0) / grandTotal * 100).toFixed(1) + '%' : '0%' }}
          </td>
          
        </tr>
      </tfoot>
      
    </table>

    <button @click="exportXLS()" class="button is-info" >Export to Excel</button>

   

     
    
  </div>
</template>

<script>

import OrderService from '@/services/OrderService.js';
//import SalesService from '@/services/SalesService.js';
import XLSX from 'xlsx';
import OrderMixin from '@/mixins/OrderMixin.js';

const GARMENT_REPORT_SELECTED_IDS_STORAGE_KEY = 'oneills_reports_garment_report_selected_garment_ids';
const GARMENT_REPORT_START_DATE_STORAGE_KEY = 'oneills_reports_garment_report_start_date';
const GARMENT_REPORT_END_DATE_STORAGE_KEY = 'oneills_reports_garment_report_end_date';

export default {
  name:'EarlyOrders',
  mixins: [OrderMixin],
  components: {
   	
  },
  data() {
    return {
      client_id: '',
       clients: [],
      orders: [],
      users: [],
      username: '',
      start_date: this.getStartDate(),
        end_date: new Date().toISOString().slice(0,10),
      currentSort: 'count',
      currentSortDir: 'desc',
      garments: [],
      selected_garment_id: '',
      selected_garment_ids: [],
      garment_selection_error: '',
     accessToken: '',
     clients_loading:true,
      orders_loading:false,
     garments_loading:true,
     VUE_APP_ASP_URL:process.env.VUE_APP_ASP_URL,

     range: '',
     sizes: [],
     selected_region: ''
     
    }
  },
  created() {
      this.restoreFiltersFromStorage();
      this.getAccessToken()
        .then(() => { 
            this.getGarments();
            this.getSizes();
        });
      
    },
  methods: {
    async getAccessToken() {
        this.accessToken = await this.$auth.getTokenSilently()
    },
    exportXLS() {
		 //alert("hi")
		 var wb = XLSX.utils.table_to_book(document.getElementById('orderstable'), {sheet:"Sheet 1"});
		 XLSX.writeFile(wb, 'Garment Report.xlsx')

	 },
    async getGarments() {
      this.garments_loading = true;
      OrderService.getGarments(this.accessToken)
        .then(
          (garments => {
            this.$set(this, 'garments', garments || []);
            this.garments_loading = false;
          }).bind(this)
        )
        .catch(() => {
          this.garments_loading = false;
        });
    },
    addSelectedGarment() {
      if (this.selected_garment_id === '') {
        return;
      }

      if (this.selected_garment_ids.indexOf(this.selected_garment_id) === -1) {
        this.selected_garment_ids.push(this.selected_garment_id);
        this.saveFiltersToStorage();
      }

      this.garment_selection_error = '';
      this.selected_garment_id = '';
    },
    removeSelectedGarment(garment_id) {
      this.selected_garment_ids = this.selected_garment_ids.filter(id => id !== garment_id);
      this.saveFiltersToStorage();
    },
    saveFiltersToStorage() {
      localStorage.setItem(GARMENT_REPORT_SELECTED_IDS_STORAGE_KEY, JSON.stringify(this.selected_garment_ids));
      localStorage.setItem(GARMENT_REPORT_START_DATE_STORAGE_KEY, this.start_date || '');
      localStorage.setItem(GARMENT_REPORT_END_DATE_STORAGE_KEY, this.end_date || '');
    },
    restoreFiltersFromStorage() {
      const storedStartDate = localStorage.getItem(GARMENT_REPORT_START_DATE_STORAGE_KEY);
      const storedEndDate = localStorage.getItem(GARMENT_REPORT_END_DATE_STORAGE_KEY);
      const storedSelectedGarmentIds = localStorage.getItem(GARMENT_REPORT_SELECTED_IDS_STORAGE_KEY);

      if (storedStartDate) {
        this.start_date = storedStartDate;
      }

      if (storedEndDate) {
        this.end_date = storedEndDate;
      }

      if (storedSelectedGarmentIds) {
        try {
          const parsedIds = JSON.parse(storedSelectedGarmentIds);
          if (Array.isArray(parsedIds)) {
            this.selected_garment_ids = parsedIds;
          }
        } catch (e) {
          this.selected_garment_ids = [];
        }
      }

      
    },
   
    async getOrders() {
      if (this.selected_garment_ids.length === 0) {
        this.garment_selection_error = 'Please select at least one garment before loading orders.';
        this.orders = [];
        this.orders_loading = false;
        return;
      }

      this.garment_selection_error = '';
      this.orders_loading=true;
        OrderService.getOrdersForGarments(this.accessToken, '', this.range, this.start_date, this.end_date, "", 1, '', this.selected_garment_ids)
          .then(
              (orders => {
              this.$set(this, "orders", orders);
              this.orders_loading=false;
            }).bind(this)
          );
    },
    
    getStartDate() {
            
            var d = new Date();
            
            d.setDate(d.getDate() - 7);
            return d.toISOString().slice(0,10);
             
        },
   
  },
  computed : {
      selectedGarments: function () {
        return this.garments.filter(garment => this.selected_garment_ids.indexOf(garment.garmentID) !== -1);
      },
      regionOptions: function () {
        var regions = this.orders
          .map(function (order) { return order.region; })
          .filter(function (region, index, self) { return region && self.indexOf(region) === index; });
        return regions.sort();
      },
      filteredOrders: function () {
        if (!this.selected_region) {
          return this.orders;
        }
        return this.orders.filter(order => order.region === this.selected_region);
      },
      activeSizes: function () {
        return this.sizes.filter(size =>
          this.filteredOrders.some(order => order[size.database_name] > 0)
        );
      },
      sizeTotals: function () {
        var totals = {};
        this.activeSizes.forEach(size => {
          totals[size.database_name] = this.filteredOrders.reduce(function (sum, order) {
            return sum + (Number(order[size.database_name]) || 0);
          }, 0);
        });
        return totals;
      },
      grandTotal: function () {
        return this.filteredOrders.reduce(function (sum, order) {
          return sum + (Number(order.total_qty) || 0);
        }, 0);
      }
  },

 
  mounted() {
    
  },
  watch: {
    
    start_date: function () {
      this.saveFiltersToStorage();
    },
    end_date: function () {
      this.saveFiltersToStorage();
    },
  }
}



</script>


